import { ChangeDetectionStrategy, Component } from '@angular/core';
import type { SafeHtml } from '@angular/platform-browser';

import { TranslatePipe } from '@recruitee/i18n';
import type { DialogComponentI } from '@recruitee/user-interface';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogRef,
  DialogWidth,
  HeadingComponent,
} from '@recruitee/user-interface';

import { IntegrationListLegalDialogContentComponent } from './integration-list-legal-dialog-content/integration-list-legal-dialog-content.component';

export type IntegrationListLegalDialogData = {
  partnerName: string;
  helpArticleUrl: string | null;
  textOverClaims: string;
  claimsHeading?: SafeHtml;
  claims: SafeHtml[];
  textUnderClaims?: SafeHtml;
  buttonText: string;
  listType?: string;
};

export const IntegrationListLegalDialogConfig = {
  width: DialogWidth.SmallXX,
};

@Component({
  selector: 'rti-integration-list-legal-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './integration-list-legal-dialog.component.html',
  imports: [
    ButtonComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    HeadingComponent,
    TranslatePipe,
    IntegrationListLegalDialogContentComponent,
  ],
})
export class IntegrationListLegalDialogComponent
  implements DialogComponentI<IntegrationListLegalDialogData, boolean>
{
  public dialogData: IntegrationListLegalDialogData;

  constructor(public dialog: DialogRef) {}

  public setDialogData(data: IntegrationListLegalDialogData): void {
    this.dialogData = data;
  }

  public close(): void {
    this.dialog.close();
  }

  public accept(): void {
    this.dialog.close({ accepted: true });
  }
}
